
import { useAuthContext } from '../../contexts/AuthContext';
import { signOut } from 'aws-amplify/auth';
import fired from '../../assets/images/suspended.png'
import I18n from '../../contexts/I18n';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';

const SuspendedScreen = () => { // = (navParams: any) ... console.log('shiftId!', navParams.route.params.shiftId);
    // AUTH
    const {userId: AuthUserId, setUser} = useAuthContext();
    // I18N
    const { t } = useTranslation();
    const savedLang = Cookies.get('language');
    const [locale, setLocale] = useState(savedLang || "en");

    const handleSignOut = async () => {
        try {
          await signOut();
          setUser(null);
        } catch (error) {
          console.log('error signing out: ', error);
        };
    };

    useEffect(() => {
        handleSignOut();
    }, []);

    return (
        <div className="suspendedContainer">
            <h2 style={{textAlign: 'center', fontWeight: 'bold', fontSize: 18, paddingTop: 20, paddingBottom: 20}}>
            {t('suspended.accountSuspended')}
            </h2>
            
            <img src="/error/suspended.png" style={{width: 360, height: 300, margin: '0 auto'}}/>
            <h3 style={{textAlign: 'center', fontWeight: 'bold', fontSize: 18, paddingTop: 20, paddingBottom: 20, color: 'red'}}>
            {t('suspended.contactCompany')}
            </h3>
            {/* <Button style={{borderColor: 'red', backgroundColor: 'maroon', width: '60%', alignSelf: 'center'}} onClick={handleSignOut} title={"          " +t('suspended.tryAgain')+ "          "}>{"          " +t('suspended.tryAgain')+ "          "}</Button> */}
        </div>
    );
};

export default SuspendedScreen;
